import { apiForPrivate } from '.';
import { TRANSFORMER_SCRIPT_ENDPOINT } from '../../config/ap';

const apiScriptMaps = apiForPrivate.injectEndpoints({

    overrideExisting: true,

    endpoints: build => ({
        getTransformerScript: build.query({
            query: clientId => `${TRANSFORMER_SCRIPT_ENDPOINT.SCRIPTS}?clientId=${clientId}`,
        }),
        testTransformerScript: build.mutation({
            query: (payload) => ({
                url: TRANSFORMER_SCRIPT_ENDPOINT.TEST,
                method: 'POST',
                body: payload,
            }),
        }),
        createTransformerScript: build.mutation({
            query: (payload) => ({
                url: TRANSFORMER_SCRIPT_ENDPOINT.SCRIPTS,
                method: 'POST',
                body: payload,
            }),
        }),
        updateTransformerScript: build.mutation({
            query: ({id, payload}) => ({
                url: `${TRANSFORMER_SCRIPT_ENDPOINT.SCRIPTS}/${id}`,
                method: 'PUT',
                body: payload,
            }),
        }),

    })
});

export const {
    useLazyGetTransformerScriptQuery,
    useCreateTransformerScriptMutation,
    useUpdateTransformerScriptMutation,
    useTestTransformerScriptMutation,
} = apiScriptMaps;